import Image from 'components/common/Image';
import { Box, Button } from 'grommet';
import React from 'react';
import FileHandler from '../fileHandler/ImageUploader';

type AssetImageEditorProps = {
  values: any;
  setFieldValue: any;
};

const AssetImageEditor = ({ values, setFieldValue }: AssetImageEditorProps) => (
  <Box width="medium">
    <Box elevation="large" background="light-3" height="small">
      {values.image ? (
        <Image src={values.image} />
      ) : (
        <FileHandler
          setImage={(image: string) => setFieldValue('image', image)}
        />
      )}
    </Box>
    <Box direction="row" align="center" justify="center" pad="small">
      <Button
        label="Fjern bilde"
        onClick={() => setFieldValue('image', undefined)}
      />
    </Box>
  </Box>
);

export default AssetImageEditor;
